enum Types {
  GET_ALL_ADVISORS_REQUEST = 'GET_ALL_ADVISORS_REQUEST',
  GET_ALL_ADVISORS_FULFILLED = 'GET_ALL_ADVISORS_FULFILLED',
  GET_ALL_ADVISORS_REJECTED = 'GET_ALL_ADVISORS_REJECTED',

  GET_ADVISOR_REQUEST = 'GET_ADVISOR_REQUEST',
  GET_ADVISOR_FULFILLED = 'GET_ADVISOR_FULFILLED',
  GET_ADVISOR_REJECTED = 'GET_ADVISOR_REJECTED',

  APPLY_ADVISOR_REQUEST = 'APPLY_ADVISOR_REQUEST',
  APPLY_ADVISOR_FULFILLED = 'APPLY_ADVISOR_FULFILLED',
  APPLY_ADVISOR_REJECTED = 'APPLY_ADVISOR_REJECTED',

  IGNORE_ADVISOR_REQUEST = 'IGNORE_ADVISOR_REQUEST',
  IGNORE_ADVISOR_FULFILLED = 'IGNORE_ADVISOR_FULFILLED',
  IGNORE_ADVISOR_REJECTED = 'IGNORE_ADVISOR_REJECTED',

  REVERT_ADVISOR_REQUEST = 'REVERT_ADVISOR_REQUEST',
  REVERT_ADVISOR_FULFILLED = 'REVERT_ADVISOR_FULFILLED',
  REVERT_ADVISOR_REJECTED = 'REVERT_ADVISOR_REJECTED',

  GET_DASHBOARD_REQUEST = 'GET_DASHBOARD_REQUEST',
  GET_DASHBOARD_FULFILLED = 'GET_DASHBOARD_FULFILLED',
  GET_DASHBOARD_REJECTED = 'GET_DASHBOARD_REJECTED',
}

export default Types;
